import styled from 'styled-components';

import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100%;

  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
  margin-bottom: 8px;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.onSurfaceVariant};
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 800;
  color: ${colors.onSurface};
  margin-bottom: 16px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 20px;
`;

export const Card = styled.div`
  padding: 24px;
  border-radius: ${radius.md};
  background-color: ${colors.surfaceContainerLow};
`;

export const CardTitle = styled.h3`
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 20px;
`;

export const VerticalChart = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 140px;
`;

export const VerticalBarColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  height: 100%;
  justify-content: flex-end;
`;

export const VerticalBarValue = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const VerticalBar = styled.div<{ height: number }>`
  width: 100%;
  max-width: 40px;
  height: ${props => Math.max(props.height, 2)}%;
  border-radius: 4px 4px 0 0;
  background-color: ${colors.primary};
  opacity: ${props => (props.height === 0 ? 0.15 : 1)};
`;

export const VerticalBarLabel = styled.span`
  font-size: 10px;
  color: ${colors.onSurfaceVariant};
  text-align: center;
`;

export const RankedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RankedRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RankedRowHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12.5px;

  span:first-child {
    color: ${colors.onSurface};
    font-weight: 600;
  }

  span:last-child {
    color: ${colors.onSurfaceVariant};
    font-weight: 700;
  }
`;

export const RankedBarTrack = styled.div`
  width: 100%;
  height: 6px;
  border-radius: ${radius.full};
  background-color: ${colors.surfaceContainerHighest};
  overflow: hidden;
`;

export const RankedBarFill = styled.div<{ percent: number }>`
  width: ${props => props.percent}%;
  height: 100%;
  background-color: ${colors.primary};
`;

export const StatRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`;

export const StatBlock = styled.div`
  flex: 1;
  min-width: 110px;
`;

export const StatValue = styled.div`
  font-size: 28px;
  font-weight: 800;
  color: ${colors.onSurface};
`;

export const StatLabel = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: ${colors.onSurfaceVariant};
`;

export const EmptyState = styled.div`
  padding: 20px 0;
  font-size: 13px;
  color: ${colors.onSurfaceVariant};
  text-align: center;
`;
